/**
 * Local-only answers block a new Medical History grant because the provider
 * cannot see them yet. They never block revoking access that is already on.
 */
export function hasPendingMedicalHistoryWrites({
  identityReady,
  hydrated,
  pendingSections,
}: {
  identityReady: boolean;
  hydrated: boolean;
  pendingSections: Partial<Record<string, number>>;
}): boolean {
  return (
    !identityReady ||
    !hydrated ||
    Object.values(pendingSections).some((count) => (count ?? 0) > 0)
  );
}

export function blocksMedicalHistorySharingGrant({
  key,
  currentlyEnabled,
  hasLocalMedicalHistory,
}: {
  key: string;
  currentlyEnabled: boolean;
  hasLocalMedicalHistory: boolean;
}): boolean {
  return (
    key === "medicalHistory" && !currentlyEnabled && hasLocalMedicalHistory
  );
}
